import { render } from "./HeroiconsSolidShoppingCart.vue?vue&type=template&id=3b085600"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShoppingCart.vue"]])

export default __exports__